var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { InputCleaner } from '../../Cleaner/InputCleaner';
export class WordTaskInput {
    // Has Inheritance Child MemorizePointsWordTaskInput, that overwrites some methods !!
    parent;
    inputValueHidden = '';
    inputValueVisible = '';
    manifestedInputValue = '';
    dateOfInputChange;
    dateOfInputFocus;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get inputValue() {
        return this.inputValueHidden || this.inputValueVisible;
    }
    set inputValue(s) {
        this.inputValueHidden = s;
        this.inputValueVisible = s;
        this.dateOfInputChange = new Date();
        /*
        const { domElement } = this.wordTask.ownAspect.input.aspectMount;
        if (domElement) {
          const measuredStyle = getComputedStyle(domElement);
          console.log('xx', this.wordTask.ownAspect.input.aspectMount.domElement.scrollWidth, measuredStyle.paddingRight);
          this.wordTask.wordTaskForm.manualInputAutoWidth =
            this.wordTask.ownAspect.input.aspectMount.domElement.scrollWidth +
            parseInt(measuredStyle.paddingRight) +
            parseInt(measuredStyle.paddingLeft);
        }*/
    }
    get inputValueDisplayed() {
        if (this.wordTask.taskProgress.isTaskCompleted && this.wordTask.wordTaskEvaluate.isCorrectToCurrentInput) {
            return this.wordTask.wordTaskNearest.revealString;
        }
        return this.inputValueVisible;
    } /*
    set inputValueDisplayed(s) {
      this.inputValue = s;
    }*/
    get inputValueForEvaluation() {
        if (this.manifestedInputValue)
            return this.manifestedInputValue;
        return this.inputValue;
    }
    inputCleaner = new InputCleaner(this);
}
__decorate([
    observable
], WordTaskInput.prototype, "inputValueHidden", void 0);
__decorate([
    observable
], WordTaskInput.prototype, "inputValueVisible", void 0);
__decorate([
    observable
], WordTaskInput.prototype, "manifestedInputValue", void 0);
__decorate([
    observable
], WordTaskInput.prototype, "dateOfInputChange", void 0);
__decorate([
    observable
], WordTaskInput.prototype, "dateOfInputFocus", void 0);
__decorate([
    computed
], WordTaskInput.prototype, "inputValueForEvaluation", null);
